'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _applyConfigs = require('../utils/apply-configs');

var _applyConfigs2 = _interopRequireDefault(_applyConfigs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	type: 'VIDEO_01',
	name: 'Video',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*'],
	category: 'Media',
	props: [{
		name: 'src',
		inputType: 'media',
		label: 'Media path',
		default: ''
	}],
	hiddenProps: (0, _applyConfigs2.default)(['htmlclass']).concat({
		label: 'Video settings',
		props: [{
			name: 'autoplay',
			inputType: 'checkbox',
			label: 'Autoplay video',
			default: false
		}, {
			name: 'controls',
			inputType: 'checkbox',
			label: 'Show controls',
			default: false
		}, {
			name: 'loop',
			inputType: 'checkbox',
			label: 'Loop video',
			default: false
		}, {
			name: 'muted',
			inputType: 'checkbox',
			label: 'Mute video',
			default: false
		}, {
			name: 'aspectRatio',
			inputType: 'text',
			label: 'Aspect ratio',
			default: '16:9'
		}, {
			name: 'poster',
			inputType: 'media',
			label: 'Poster path',
			default: ''
		}, {
			name: 'url',
			inputType: 'link',
			label: 'Link (Set Autoplay on, Mute on & Controls off)',
			default: '',
			requestKey: 'linkFriendlyName'
		}]
	})
};